var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-overlay"},[_c('div',{staticClass:"inner"},[_c('b',[_vm._v(_vm._s(_vm.msg))]),_c('P',[_vm._v("Item must be removed and problem solved."),_c('br'),_vm._v("Ask manager for help.")]),_vm._m(0),_c('button',{attrs:{"type":"button"},on:{"click":_vm.confirm}},[_vm._v("OK")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('i',[_vm._v("Please confirm that you removed the item!")])])
}]

export { render, staticRenderFns }